import React, { useEffect, useState, useRef } from 'react';
import './index.css';
import axios from 'axios';
import { UTILS } from '../../constants';
import { getShortLetters, getUserColor } from '../../utils/function';
import projectBlurr from '../../assets/images/projectblur.jpg';
import notificationNillImg from '../../assets/images/taco.svg';
export default function NotificationTrello({
  notificationCount,
  onPressCard,
  handleShow,
  setGetParams,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setSount] = useState(notificationCount?notificationCount:0); // State to store notifications
  const [notifications, setNotifications] = useState([]); // State to store notifications
  const [dropdownHeight, setDropdownHeight] = useState(0);
  const [page, setPage] = useState(1); // State to track current page
  const [hasMore, setHasMore] = useState(true); // State to track if more notifications are available
  const dropdownRef = useRef(null);

  // console.log("notificationCount",notificationCount);

  const fetchNotifications = async (currentPage) => {
    try {
      const randomString = Math.random().toString(36).substring(2, 5);
      const response = await axios.get(
        `${UTILS.API_url}board/v1/board-list-cards/notifications/all?cache=${randomString}`,
        {
          params: {
            per_page: 15,
            page: currentPage,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const newNotifications = response.data.notifications;

      // If new notifications are found, append them to the list
      // console.log("newNotifications",newNotifications);

      if (newNotifications.length > 0) {
        setNotifications((prevNotifications) => [
          ...prevNotifications,
          ...newNotifications,
        ]);
      } else {
        setHasMore(false); // No more notifications to load
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchNotifications(1); // Fetch first page of notifications when dropdown is opened
    }
  }, [isOpen]);

  const loadMoreNotifications = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchNotifications(nextPage); // Fetch next page of notifications
  };

  const markallasread = async () => {
    const url =
      UTILS.API_url +
      `board/v1/board-list-cards/notifications/mark-all-as-read`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      // console.log('response', response);

      if (response.status === 200) {
        // toast.success('Successfully Added');
      }
    } catch (error) {
      // toast.error(error.response?.data?.errors?.client_id?.[0]);
    }
  };

  const toggleDropdown = () => {
    if(isOpen === false){
      markallasread();
      setSount(0);
    }
    setIsOpen(!isOpen);
  };

  const adjustDropdownHeight = () => {
    if (dropdownRef.current) {
      const windowHeight = window.innerHeight;
      const maxDropdownHeight = windowHeight * 0.8;
      const contentHeight = dropdownRef.current.scrollHeight;

      setDropdownHeight(
        contentHeight <= maxDropdownHeight ? contentHeight : maxDropdownHeight
      );
    }
  };

  useEffect(() => {
    if (isOpen) {
      adjustDropdownHeight();
    }

    window.addEventListener('resize', adjustDropdownHeight);

    return () => {
      window.removeEventListener('resize', adjustDropdownHeight);
    };
  }, [isOpen]);

  useEffect(() => {
    if (dropdownRef.current) {
      const observer = new MutationObserver(() => {
        adjustDropdownHeight();
      });

      observer.observe(dropdownRef.current, {
        childList: true,
        subtree: true,
      });

      return () => {
        observer.disconnect();
      };
    }
  }, [isOpen]);

  return (
    <div className="notificationBtn">
      <div className="iconNotification bellBtn" onClick={toggleDropdown}>
        <span className="material-symbols-outlined">notifications</span>
        <span className="notificationCount" style={{ padding: '8px 4px' }}>
          {count && count > 100 ? '100+' : count}
        </span>
      </div>
      {isOpen ? (
        <div className="notificationDetail">
          <h4 className="headingNoti">Notification</h4>
          <div
            className="notiInner"
            ref={dropdownRef}
            style={{
              height: `${dropdownHeight}px`,
              overflowY:
                dropdownHeight < dropdownRef.current?.scrollHeight
                  ? 'auto'
                  : 'unset',
            }}
          >
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <div
                  className="notiWrap"
                  onClick={() => {
                    onPressCard(notification?.card);
                    setGetParams(notification?.card.id);
                    handleShow();
                  }}
                >
                  <div
                    className="notiList"
                    key={index}
                    onClick={() => {
                      onPressCard(notification?.card);
                      setGetParams(notification?.card.id);
                      handleShow();
                    }}
                  >
                    <div className="notiIconActive">
                      <button className="activenoti btncircle"></button>
                    </div>
                    <div className="notiCardHeader">
                      <div className="imgnoti">
                        <img
                          src={
                            notification?.card?.cover_image_thumbnail ||
                            projectBlurr
                          }
                          alt="Notification"
                          onError={(e) => {
                            e.target.src = projectBlurr;
                          }}
                        />
                        {/* <img
                            src={notification?.card?.cover_image_thumbnail}
                            alt="Notification"
                          /> */}
                      </div>
                      <span
                        className="cardName"
                        title={notification?.card?.title}
                      >
                        {notification?.card?.title}
                      </span>
                    </div>
                    <div className="notiCardBody">
                      <div
                        className={`avatar d-flex align-items-center justify-content-center color${getUserColor(
                          notification?.activity_user?.name
                        )}`}
                      >
                        <p>
                          {getShortLetters(notification?.activity_user?.name)}
                        </p>
                      </div>
                      <div className="upd-name-div">
                        <span>
                          <span className="upd-name">
                            {notification?.activity_user?.name}
                          </span>{' '}
                          <span className="attachment-span">
                            {notification.message}
                          </span>{' '}
                          <span className="upd-date">
                            {notification.created_at}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="notiCardfooter">
                      <div className="notiParagaraph spaceLeftNoti">
                        <a href={notification.link}>{notification.link_text}</a>
                        <span
                          className="lineElipse"
                          dangerouslySetInnerHTML={{
                            __html: notification?.card?.description,
                          }}
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="noNoti">
                <img
                  src={notificationNillImg}
                  alt="Taco"
                  className="img-fluid"
                />
                <p className="notificationBlank">No notifications</p>
              </div>
            )}
            {hasMore && (
              <button
                className="loadMoreBtn"
                onClick={loadMoreNotifications}
                style={{ marginTop: '10px' }}
              >
                Load More ...
              </button>
            )}
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
